$(document).ready(function(){
  function showhideDescription(){
    // if product is Bingo Set type
	if($('.product-single__description.Bingo_Set').length){
    //check for default selection state
      var selected_variant = $('select.single-option-selector.product-form__input').find(':selected').val().toLowerCase();
        if(selected_variant.indexOf("bingo cards only") >= 0){
            //only if second description is available
            if($('.product-single__description.Bingo_Set').find('.second__description').length){
                console.log('has second desc');
                //hide first and show second
                $('.product-single__description.Bingo_Set .first__description').hide();
                $('.product-single__description.Bingo_Set .second__description').show();
            }else{
                $('.product-single__description.Bingo_Set .first__description').show();
            }
        }else{
            $('.product-single__description.Bingo_Set .first__description').show();
            $('.product-single__description.Bingo_Set .second__description').hide();
        }
      }
  }
  
  //call on page load 
  showhideDescription();
  $('select.single-option-selector.product-form__input').on('change',function(){
  	showhideDescription();
  });
  
});